// import React from "react";
// import {
//   Users,
//   Target,
//   BarChart2,
//   MessageSquare,
//   Calendar,
//   Zap,
//   ArrowRight,
//   Menu,
//   X,
//   CheckCircle,
// } from "lucide-react";

// export default function CRMPage() {
//   const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);

//   return (
//     <div className="min-h-screen bg-gray-50 font-inter">
//       {/* NAVBAR */}
//       <nav className="fixed top-0 w-full bg-white border-b border-gray-200 z-50">
//         <div className="max-w-7xl mx-auto px-4 h-16 flex justify-between items-center">
//           <span className="text-2xl font-bold text-blue-900">Infronex</span>

//           <div className="hidden md:flex gap-8 items-center">
//             <a href="#features" className="text-gray-600 hover:text-blue-900">
//               Features
//             </a>
//             <a
//               href="#capabilities"
//               className="text-gray-600 hover:text-blue-900"
//             >
//               Capabilities
//             </a>
//             <a
//               href="#integrations"
//               className="text-gray-600 hover:text-blue-900"
//             >
//               Integrations
//             </a>
//             <a
//               href="#contact"
//               className="bg-blue-700 text-white px-5 py-2 rounded-md text-sm font-semibold"
//             >
//               Contact
//             </a>
//           </div>

//           <button
//             className="md:hidden"
//             onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//           >
//             {mobileMenuOpen ? <X /> : <Menu />}
//           </button>
//         </div>

//         {mobileMenuOpen && (
//           <div className="md:hidden bg-white border-t px-4 py-4 space-y-3">
//             <a href="#features" className="block">
//               Features
//             </a>
//             <a href="#capabilities" className="block">
//               Capabilities
//             </a>
//             <a href="#integrations" className="block">
//               Integrations
//             </a>
//             <a
//               href="#contact"
//               className="block bg-blue-700 text-white px-5 py-2 rounded-md text-center"
//             >
//               Contact
//             </a>
//           </div>
//         )}
//       </nav>

//       {/* HERO */}
//       <section className="pt-32 pb-20 text-center px-4 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
//         <span className="inline-block bg-blue-500/20 text-blue-200 px-4 py-1 rounded-full text-sm font-semibold mb-4 border border-blue-400/30">
//           Customer Relationship Management
//         </span>

//         <h1 className="text-4xl sm:text-5xl font-extrabold text-white mb-4">
//           CRM
//         </h1>

//         <p className="text-lg text-gray-300 max-w-2xl mx-auto mb-8">
//           Manage customers, sales, and communication from one powerful platform.
//         </p>

//         <a
//           href="#contact"
//           className="inline-flex items-center gap-2 bg-blue-600 text-white px-6 py-3 rounded-md text-sm font-semibold hover:bg-blue-700 transition"
//         >
//           Request Demo <ArrowRight size={18} />
//         </a>
//       </section>

//       {/* WHAT IS CRM */}
//       <section className="py-16 bg-gray-50">
//         <div className="max-w-7xl mx-auto px-4 grid lg:grid-cols-2 gap-12 items-center">
//           <div>
//             <h2 className="text-3xl font-bold text-gray-900 mb-4">
//               What is CRM?
//             </h2>
//             <p className="text-gray-600 mb-4">
//               CRM (Customer Relationship Management) is a centralized system
//               that helps businesses manage customer data, sales activities,
//               communication, and relationships efficiently.
//             </p>
//             <p className="text-gray-600 mb-6">
//               Our CRM enables teams to track leads, close deals faster, and
//               build long-term customer relationships using real-time insights.
//             </p>

//             <ul className="space-y-3">
//               {[
//                 "Centralized customer data",
//                 "Sales & lead tracking",
//                 "Improved customer engagement",
//                 "Real-time reporting & insights",
//               ].map((item, i) => (
//                 <li key={i} className="flex gap-3 items-center">
//                   <CheckCircle className="text-blue-700" size={18} />
//                   <span className="text-gray-700 text-sm">{item}</span>
//                 </li>
//               ))}
//             </ul>
//           </div>

//           <img
//             src="https://images.unsplash.com/photo-1553877522-43269d4ea984?w=1200&q=80"
//             alt="CRM Dashboard"
//             className="rounded-xl shadow-lg border"
//           />
//         </div>
//       </section>

//       {/* CRM CAPABILITIES */}
//       <section id="capabilities" className="py-16 bg-white">
//         <div className="max-w-7xl mx-auto px-4">
//           <div className="text-center mb-12">
//             <h2 className="text-3xl font-bold text-gray-900 mb-4">
//               CRM Capabilities
//             </h2>
//             <p className="text-gray-600 max-w-2xl mx-auto">
//               Powerful tools designed to give complete visibility, control, and
//               intelligence across your customer lifecycle.
//             </p>
//           </div>

//           {/* Capability 1 */}
//           <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
//             <div>
//               <h3 className="text-2xl font-bold text-gray-900 mb-4">
//                 Customer Insights
//               </h3>
//               <p className="text-gray-600 mb-6">
//                 Get a 360° view of every customer with complete interaction
//                 history, behavioral tracking, and engagement analytics.
//               </p>

//               <ul className="space-y-3">
//                 {[
//                   "Complete customer profiles",
//                   "Interaction & communication history",
//                   "Behavior and engagement tracking",
//                   "Customer lifetime value insights",
//                 ].map((item, i) => (
//                   <li key={i} className="flex gap-3 items-center">
//                     <CheckCircle className="text-blue-700" size={18} />
//                     <span className="text-gray-700 text-sm">{item}</span>
//                   </li>
//                 ))}
//               </ul>
//             </div>

//             <img
//               src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&q=80"
//               alt="CRM Customer Insights Dashboard"
//               className="rounded-xl shadow-lg border"
//             />
//           </div>

//           {/* Capability 2 */}
//           <div className="grid lg:grid-cols-2 gap-12 items-center mb-16 lg:grid-flow-col-dense">
//             <div className="lg:col-start-2">
//               <h3 className="text-2xl font-bold text-gray-900 mb-4">
//                 Sales Enablement
//               </h3>
//               <p className="text-gray-600 mb-6">
//                 Empower your sales team with tools that improve deal velocity,
//                 forecasting accuracy, and conversion rates.
//               </p>

//               <ul className="space-y-3">
//                 {[
//                   "Lead & opportunity management",
//                   "Deal stage tracking",
//                   "Automated follow-ups & reminders",
//                   "Accurate sales forecasting",
//                 ].map((item, i) => (
//                   <li key={i} className="flex gap-3 items-center">
//                     <CheckCircle className="text-blue-700" size={18} />
//                     <span className="text-gray-700 text-sm">{item}</span>
//                   </li>
//                 ))}
//               </ul>
//             </div>

//             <img
//               src="https://images.unsplash.com/photo-1553877522-43269d4ea984?w=1200&q=80"
//               alt="CRM Sales Dashboard"
//               className="rounded-xl shadow-lg border lg:col-start-1"
//             />
//           </div>

//           {/* Capability 3 */}
//           <div className="grid lg:grid-cols-2 gap-12 items-center">
//             <div>
//               <h3 className="text-2xl font-bold text-gray-900 mb-4">
//                 Analytics & Reporting
//               </h3>
//               <p className="text-gray-600 mb-6">
//                 Make data-driven decisions using real-time dashboards,
//                 performance metrics, and customizable reports.
//               </p>

//               <ul className="space-y-3">
//                 {[
//                   "Real-time sales dashboards",
//                   "Team performance tracking",
//                   "Pipeline & revenue reports",
//                   "Custom report generation",
//                 ].map((item, i) => (
//                   <li key={i} className="flex gap-3 items-center">
//                     <CheckCircle className="text-blue-700" size={18} />
//                     <span className="text-gray-700 text-sm">{item}</span>
//                   </li>
//                 ))}
//               </ul>
//             </div>

//             <img
//               src="https://images.unsplash.com/photo-1543286386-713bdd548da4?w=1200&q=80"
//               alt="CRM Analytics Dashboard"
//               className="rounded-xl shadow-lg border"
//             />
//           </div>
//         </div>
//       </section>

//       {/* FEATURES */}
//       <section id="features" className="py-16 bg-white">
//         <div className="max-w-7xl mx-auto px-4">
//           <h2 className="text-3xl font-bold text-center mb-12">
//             Key CRM Features
//           </h2>

//           <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
//             {[
//               {
//                 icon: Users,
//                 title: "Contact Management",
//                 desc: "Complete customer profiles and interaction history",
//               },
//               {
//                 icon: Target,
//                 title: "Sales Pipeline",
//                 desc: "Track and manage deals at every stage",
//               },
//               {
//                 icon: BarChart2,
//                 title: "Analytics",
//                 desc: "Sales insights and performance reports",
//               },
//               {
//                 icon: MessageSquare,
//                 title: "Communication",
//                 desc: "Integrated email and messaging",
//               },
//               {
//                 icon: Calendar,
//                 title: "Activity Tracking",
//                 desc: "Tasks, reminders, and follow-ups",
//               },
//               {
//                 icon: Zap,
//                 title: "Automation",
//                 desc: "Automate workflows and routine actions",
//               },
//             ].map((f, i) => (
//               <div
//                 key={i}
//                 className="bg-gray-50 p-6 rounded-lg border hover:border-blue-700 hover:shadow"
//               >
//                 <f.icon className="text-blue-700 mb-3" size={28} />
//                 <h3 className="font-bold mb-2">{f.title}</h3>
//                 <p className="text-sm text-gray-600">{f.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* INTEGRATIONS */}
//       <section id="integrations" className="py-16 bg-blue-50">
//         <div className="max-w-7xl mx-auto px-4 text-center">
//           <h2 className="text-3xl font-bold mb-4">Seamless Integrations</h2>
//           <p className="text-gray-600 mb-10">
//             Connect CRM with your existing tools effortlessly
//           </p>

//           <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
//             {[
//               "Salesforce",
//               "Microsoft 365",
//               "Google Workspace",
//               "Slack",
//               "Zoom",
//               "Mailchimp",
//               "HubSpot",
//               "Zapier",
//             ].map((tool, i) => (
//               <div
//                 key={i}
//                 className="bg-white p-5 rounded-lg border hover:border-blue-700"
//               >
//                 <span className="font-semibold">{tool}</span>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CTA */}
//       <section id="contact" className="py-16 bg-blue-900 text-center">
//         <h2 className="text-3xl font-bold text-white mb-4">
//           Grow Customer Relationships with CRM
//         </h2>
//         <p className="text-blue-100 mb-8">
//           See how Infronex CRM improves sales and customer engagement.
//         </p>
//         <a
//           href="#"
//           className="bg-white text-blue-900 px-7 py-3 rounded-md font-semibold text-sm"
//         >
//           Request Demo
//         </a>
//       </section>

//     </div>
//   );
// }

import React from "react";
import {
  Users,
  Target,
  BarChart2,
  Zap,
  CheckCircle2,
  ArrowRight,
  MessageSquare,
  Smartphone,
  ShieldCheck,
  MousePointer2,
  PieChart,
  Repeat,
} from "lucide-react";
import { Link } from "react-router-dom";

export default function CRMPage() {
  const features = [
    {
      icon: Users,
      title: "Contact Management",
      description:
        "Unified 360° view of customer interactions, communication history, and key contact details.",
    },
    {
      icon: Target,
      title: "Pipeline Management",
      description:
        "Visual sales funnels to track deals from prospect to closure with drag-and-drop simplicity.",
    },
    {
      icon: MessageSquare,
      title: "WhatsApp Integration",
      description:
        "Directly engage with Indian customers where they are. Integrated WhatsApp API for instant follow-ups.",
    },
    {
      icon: Zap,
      title: "Sales Automation",
      description:
        "Automate repetitive tasks like welcome emails, follow-up reminders, and lead assignments.",
    },
    {
      icon: PieChart,
      title: "Revenue Forecasting",
      description:
        "Predict future sales based on historical data and current pipeline health.",
    },
    {
      icon: Smartphone,
      title: "Field Force Sync",
      description:
        "Enable your field sales team to update meeting notes and lead status instantly from their phones.",
    },
  ];

  return (
    <main className="bg-white selection:bg-blue-100 font-inter">
      {/* ========== HERO SECTION ========== */}
      <section className="relative h-[450px] flex items-center overflow-hidden bg-[#0a192f]">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-20 scale-105"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&q=80&w=1600')",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a192f]/50 to-[#0a192f]" />

        <div className="relative max-w-7xl mx-auto px-6 w-full">
          <div className="max-w-2xl text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-500/10 border border-blue-500/20 text-blue-400 text-[10px] font-bold tracking-[0.2em] uppercase mb-4">
              Growth Accelerator
            </div>
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 tracking-tight leading-tight">
              Customer <span className="text-blue-500">Relationship</span>{" "}
              Management.
            </h1>
            <p className="text-base text-slate-400 text-white max-w-lg mb-8 leading-relaxed font-light">
              Beyond simple databases. A high-velocity CRM engineered to turn
              your leads into loyal customers with intelligent automation.
            </p>
            <div className="flex gap-3 flex-wrap">
              <Link
                to="/contact"
                className="bg-blue-600 text-white px-6 py-2.5 rounded-lg text-sm font-bold hover:bg-blue-700 transition-all flex items-center gap-2 shadow-lg shadow-blue-900/40"
              >
                Get started <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ========== CORE VALUE PROPOSITION ========== */}
      <section className="py-24">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-5 text-left">
              <span className="text-blue-600 text-[11px] font-bold tracking-[0.2em] uppercase block mb-4">
                The Advantage
              </span>
              <h2 className="text-3xl font-bold text-slate-900 mb-6 tracking-tight leading-tight">
                Empower your sales team with <br />
                <span className="text-slate-400">Contextual Intelligence.</span>
              </h2>
              <p className="text-slate-600 mb-8 leading-relaxed text-sm">
                Infronex CRM eliminates the guesswork. Your team knows exactly
                who to call, when to call, and what to say based on real-time
                behavior data.
              </p>
              <div className="space-y-4">
                {[
                  {
                    t: "360° Interaction History",
                    d: "Every call, email, and chat in one place.",
                  },
                  {
                    t: "Automated Lead Scoring",
                    d: "Focus on leads most likely to convert.",
                  },
                ].map((item, i) => (
                  <div
                    key={i}
                    className="flex gap-4 p-4 rounded-xl bg-slate-50 border border-slate-100"
                  >
                    <CheckCircle2
                      className="text-blue-600 shrink-0"
                      size={20}
                    />
                    <div className="text-left">
                      <h4 className="text-sm font-bold text-slate-900">
                        {item.t}
                      </h4>
                      <p className="text-xs text-slate-500 mt-1">{item.d}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="lg:col-span-7 relative">
              <div className="absolute -inset-4 bg-blue-100/30 rounded-[2rem] -z-10 blur-xl" />
              <img
                src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80&w=1200"
                alt="CRM Data View"
                className="rounded-2xl shadow-2xl border border-slate-100"
              />
            </div>
          </div>
        </div>
      </section>

      {/* ========== OPERATIONAL IMPACT CARDS ========== */}
      <section className="py-24 bg-slate-50 border-y border-slate-100">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-blue-600 text-[11px] font-bold tracking-[0.2em] uppercase block mb-3">
              Workflow Efficiency
            </span>
            <h2 className="text-3xl font-bold text-slate-900 tracking-tight">
              How it transforms your sales
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white border border-slate-200 p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 group text-left">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-blue-50 text-blue-600 mb-6 group-hover:bg-blue-600 group-hover:text-white transition-all duration-300">
                <MousePointer2 size={24} />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-4 tracking-tight group-hover:text-blue-600 transition-colors">
                Lead Capturing
              </h3>
              <p className="text-sm text-slate-500 leading-relaxed font-light">
                Instantly capture leads from your website, social media, and
                Google Ads directly into your pipeline.
              </p>
            </div>

            <div className="bg-white border border-slate-200 p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 group text-left">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-blue-50 text-blue-600 mb-6 group-hover:bg-blue-600 group-hover:text-white transition-all duration-300">
                <Repeat size={24} />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-4 tracking-tight group-hover:text-blue-600 transition-colors">
                Smart Follow-ups
              </h3>
              <p className="text-sm text-slate-500 leading-relaxed font-light">
                Never miss a client call. Automated WhatsApp and Email triggers
                keep your brand on top of mind.
              </p>
            </div>

            <div className="bg-white border border-slate-200 p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 group text-left">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-blue-50 text-blue-600 mb-6 group-hover:bg-blue-600 group-hover:text-white transition-all duration-300">
                <ShieldCheck size={24} />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-4 tracking-tight group-hover:text-blue-600 transition-colors">
                Secure Ownership
              </h3>
              <p className="text-sm text-slate-500 leading-relaxed font-light">
                Your customer data stays with you. Encrypted storage and
                role-based access ensure absolute security.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ========== KEY CAPABILITIES (ENHANCED CARD STYLE) ========== */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-blue-600 text-[11px] font-bold tracking-[0.2em] uppercase block mb-3">
              Enterprise Stack
            </span>
            <h2 className="text-3xl font-bold text-slate-900 tracking-tight">
              Technical Domain Capabilities
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((f, i) => (
              <div
                key={i}
                className="group bg-white border border-slate-100 p-8 rounded-2xl shadow-sm hover:shadow-md hover:border-blue-500/30 transition-all duration-300 text-left relative overflow-hidden"
              >
                <div className="absolute top-0 right-0 w-24 h-24 bg-blue-50/50 rounded-full -mr-12 -mt-12 group-hover:bg-blue-100 transition-colors" />

                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-slate-50 text-slate-900 mb-6 group-hover:bg-blue-600 group-hover:text-white transition-all duration-300 shadow-sm relative z-10">
                  <f.icon size={20} />
                </div>

                <h3 className="text-[17px] font-bold text-slate-900 mb-3 tracking-tight group-hover:text-blue-600 transition-colors relative z-10">
                  {f.title}
                </h3>

                <p className="text-[13px] text-slate-500 leading-relaxed font-normal relative z-10">
                  {f.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ========== FINAL CTA ========== */}
      <section className="py-24 bg-[#0a192f] relative overflow-hidden">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full opacity-10 pointer-events-none">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[300px] bg-blue-500 rounded-full blur-[100px]" />
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-white mb-6 tracking-tight">
            Scale your sales velocity.
          </h2>
          <p className="text-slate-400 mb-8 font-light max-w-xl mx-auto leading-relaxed">
            Ready to organize your customer data? Let’s setup a personalized
            demo tailored to your sales process.
          </p>
          <div className="flex justify-center">
            <Link
              to="/contact"
              className="bg-white text-slate-900 px-8 py-2.5 rounded-lg text-sm font-bold hover:bg-indigo-50 transition-all shadow-xl"
            >
              Initiate Technical Demo
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}